import { Segmented } from "../../../mui/Segmented";
import type { RunTab } from "../../../lib/api";

function tabKey(tab: RunTab, idx: number): string {
  if (tab.kind === "yesterday") return "yesterday";
  if (tab.kind === "unassigned") return "unassigned";
  return `project:${tab.projectId}:${idx}`;
}

function tabLabel(tab: RunTab): string {
  if (tab.kind === "yesterday") return tab.badge > 0 ? `Yesterday ${tab.badge}` : "Yesterday";
  if (tab.kind === "unassigned") return tab.badge > 0 ? `Unassigned ${tab.badge}` : "Unassigned";
  return tab.badge > 0 ? `${tab.name} ${tab.badge}` : tab.name;
}

export function RailTabs({
  tabs,
  tabIdx,
  onChange,
}: {
  tabs: RunTab[];
  tabIdx: number;
  onChange: (idx: number) => void;
}) {
  const options = tabs.map((t, i) => ({
    key: tabKey(t, i),
    label: tabLabel(t),
    tone: t.kind === "project" && t.rollups.blocked > 0 ? ("danger" as const) : undefined,
  }));
  const value = options[tabIdx]?.key ?? options[0]?.key ?? "yesterday";

  return (
    <div style={{ marginBottom: 18, overflowX: "auto" }}>
      <Segmented
        value={value}
        onChange={(k) => {
          const i = options.findIndex((o) => o.key === k);
          if (i >= 0) onChange(i);
        }}
        options={options}
      />
    </div>
  );
}
